var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgString(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77083 2.83331V4.98068H5.34978V13.5702H7.49714V4.98068H11.0761V2.83331H1.77083ZM15.3708 6.41226H8.92872V8.55963H11.0761V13.5702H13.2235V8.55963H15.3708V6.41226Z",
    fill: "#0F1C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgString);
export default __webpack_public_path__ + "static/media/string.9d598b04dc442b32a8848bcadb65304d.svg";
export { ForwardRef as ReactComponent };